import { render } from "./MarketingWeekDaySelect.vue?vue&type=template&id=2ce4e27a&scoped=true"
import script from "./MarketingWeekDaySelect.vue?vue&type=script&lang=js"
export * from "./MarketingWeekDaySelect.vue?vue&type=script&lang=js"

import "./MarketingWeekDaySelect.vue?vue&type=style&index=0&id=2ce4e27a&lang=scss&scoped=true"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce4e27a"]])

export default __exports__